import styled from 'styled-components'
import Wrapper from 'common/wrapper'

const StaticWarrantyStyled = styled.div`
  background: var(--neutral110);
  color: var(--white);
  position: relative;
  margin-block-end: 80px;
  margin-block-start: 80px;
  .diamond-container {
    position: relative;
    /* min-height: calc(100vh - var(--headerBlockSize)); */
  }
  .diamond {
    position: absolute;
    width: 60%;
    max-width: 426px;
    display: block;
    margin: 0 auto;
    top: -3%;
    left: 0;
    right: 0;
    img {
      max-width: 100%;
      height: auto;
    }
  }
  .warranty {
    max-width: 426px;
    display: block;
    margin: 0 auto;
  }
  .warranty {
    font: var(--smallRegular);
    text-transform: uppercase;
    text-align: center;
  }
  .satisfaction {
    max-width: 100%;
    height: auto;
    margin-top: 30%;
  }
  @media (min-width: 768px) {
    .diamond {
      img {
        display: block;
        margin: 0 auto;
        max-width: 330px;
      }
    }
    .diamond-container {
      min-height: auto;
    }
    .warranty {
      font: var(--headline5);
      font-weight: 400;
    }
  }
  @media (min-width: 1024px) {
    position: relative;
    margin-block-end: 120px;
    .diamon-container {
      max-height: calc(100vh - var(--headerBlockSize));
    }
    .satisfaction {
      margin-top: 0;
    }
    .ligth-container {
      bottom: 0;
    }
    .cards-container {
      position: absolute;
    }
    .satisfaction {
      max-height: calc(100vh - var(--headerBlockSize));
    }
  }
  @media (min-width: 1366px) {
    .diamond-container {
      max-height: 888px;
    }
    .satisfaction {
      margin-top: 0;
    }
  }
  @media (min-width: 1440px) {
    .warranty {
      margin-top: 24px;
    }
  }
  @media (min-aspect-ratio: 2 / 1) {
    .diamon {
      top: -8px;
      img {
        max-width: 300px;
      }
      font: var(--headline6);
    }
  }
`

function StaticWarranty() {
  return (
    <StaticWarrantyStyled aria-labelledby="#warranty">
      <Wrapper maxWidth={1200}>
        <div className="diamond-container">
          <div className="diamond">
            <img
              width="426"
              height="426"
              src="/images/course/diamante.png"
              alt="Satisfaccion 100% garantizada por nuestro diamante"
            />
            <p className="warranty" id="warranty">
              Si no aprendes algo nuevo, te devolvemos tu dinero
            </p>
          </div>
          <div className="ligth-container">
            <img
              width="1366"
              height="858"
              className="satisfaction"
              src="/images/course/base-satisfaccion.svg"
              alt="Satisfaccion 100% garantizada por nuestro diamante"
            />
          </div>
        </div>
      </Wrapper>
    </StaticWarrantyStyled>
  )
}

export default StaticWarranty
